import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { addTemporaryToast } from "shared/components/Toast";
import { IAPIState, IStatus } from "shared/types";
import { DeleteModal } from "shared/components";
import { copy } from "shared/assets";

import { dataMetaSelector, deleteBandInvitation } from "Bands/state";
import { BAND_ACTIONS, IBandInvitation } from "Bands/types";
import { useClearActionMetaOnUnMount } from "Bands/utils";
import {
  InvitationActionSourceType,
  useBandContext,
  useBandInvitationContext,
} from "Bands/contexts";

const deleteInvitationCopy = copy.members.deleteInvitation;

interface DeleteBandInvitationModalProps {
  invitation: IBandInvitation;
  handleClose: () => void;
}

export const DeleteBandInvitationModal: React.FC<DeleteBandInvitationModalProps> = ({
  invitation,
  handleClose,
}) => {
  const dispatch = useDispatch();

  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.deleteBandInvitation));

  useClearActionMetaOnUnMount(BAND_ACTIONS.deleteBandInvitation);

  const { bandId } = useBandContext();
  const { fetchSentInvitations, fetchPendingInvitations, invitationActionSource } =
    useBandInvitationContext();

  useEffect(() => {
    if (!bandId) return;

    if (apiMeta?.status === IAPIState.succeeded) {
      // refetech pending invitations
      invitationActionSource === InvitationActionSourceType.pending && fetchPendingInvitations();

      // refetech sent invitations
      invitationActionSource === InvitationActionSourceType.sent && fetchSentInvitations();

      handleClose();
      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: deleteInvitationCopy.messages.success,
        })
      );
    }
  }, [
    dispatch,
    apiMeta,
    handleClose,
    bandId,
    fetchSentInvitations,
    invitationActionSource,
    fetchPendingInvitations,
  ]);

  const handleDelete = () => {
    if (invitation) {
      dispatch(deleteBandInvitation(invitation.id));
    }
  };

  return (
    <DeleteModal
      handleClose={handleClose}
      handleDelete={handleDelete}
      name={invitation.email}
      apiMeta={apiMeta}
      type="invitation"
    />
  );
};
